import {QueryKey, useQuery, UseQueryOptions} from '@tanstack/react-query';
import {getRestaurants} from 'api/requests';
import {IProvider, IRestaurantRequest} from 'types';

export const useRestaurants = (queryKey: QueryKey, query: IRestaurantRequest, options: UseQueryOptions<IProvider>) => {
  return useQuery<IProvider>({
    queryKey,
    queryFn: () => getRestaurants(query),
    staleTime: 0,
    ...options,
  });
};
